var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8 17.6c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.2-2.7-2.7-2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9 28.5c-1.8 0-3.5-.7-4.7-2h4.2c1.4 0 2.5-1.1 2.5-2.5V7c0-1.4-1.1-2.5-2.5-2.5H9.5C8.1 4.5 7 5.6 7 7v17c0 1.4 1.1 2.5 2.5 2.5h3.4c1.4 1.9 3.6 3 6 3 4.2 0 7.5-3.3 7.5-7.5h-1c0 3.6-2.9 6.5-6.5 6.5zm-8.8-8.2c0-2 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7-3.7-1.7-3.7-3.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9 10.7c0-.2-.1-.3-.2-.4L23.2 8c-.4-.2-.8 0-.8.4l-.3 4c0 .1.1.3.2.4l1.1.9c.1.1.2.2.2.3l.8 7c0 .2.3.4.5.4h1.8c.3 0 .5-.2.5-.5l-.3-10.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallbox);
export default __webpack_public_path__ + "static/media/wallbox.01ccf308f5acd3210b2928b752da33bc.svg";
export { ForwardRef as ReactComponent };